/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface DatasetRowSelectorChangeOut
 */
export interface DatasetRowSelectorChangeOut {
  /**
   *
   * @type {boolean}
   * @memberof DatasetRowSelectorChangeOut
   */
  changed: boolean;
  /**
   *
   * @type {string}
   * @memberof DatasetRowSelectorChangeOut
   */
  reasonIfNot?: string | null;
}

/**
 * Check if a given object implements the DatasetRowSelectorChangeOut interface.
 */
export function instanceOfDatasetRowSelectorChangeOut(
  value: object
): value is DatasetRowSelectorChangeOut {
  if (!('changed' in value) || value['changed'] === undefined) return false;
  return true;
}

export function DatasetRowSelectorChangeOutFromJSON(json: any): DatasetRowSelectorChangeOut {
  return DatasetRowSelectorChangeOutFromJSONTyped(json, false);
}

export function DatasetRowSelectorChangeOutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DatasetRowSelectorChangeOut {
  if (json == null) {
    return json;
  }
  return {
    changed: json['changed'],
    reasonIfNot: json['reason_if_not'] == null ? undefined : json['reason_if_not']
  };
}

export function DatasetRowSelectorChangeOutToJSON(value?: DatasetRowSelectorChangeOut | null): any {
  if (value == null) {
    return value;
  }
  return {
    changed: value['changed'],
    reason_if_not: value['reasonIfNot']
  };
}
